
import React from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import "../../styles/PaperStyles.css"; // Import paper-specific styles

const Paper = () => {
  return (
    <div className="paper-page">
      <Header />
      <div className="site-title" style={{ fontSize: '1.5rem', lineHeight: 1.4, marginTop: 20, textAlign: 'center' }}>
        Enhancing Orthopedic Surgical Training With<br />Interactive Photorealistic 3D Visualization
      </div>
      <section className="authors" style={{ marginTop: 20, fontSize: '1rem', lineHeight: 1.6, textAlign: 'center' }}>
        <span>Roni Lekar<sup>*1</sup></span>{' '}
        <span>Tatiana Gerth<sup>1</sup></span>{' '}
        <span>Sergey Prokudin<sup>2,3</sup></span>{' '}
        <span>Matthias Seibold<sup>3</sup></span>{' '}
        <span>Reto Bürgin<sup>1</sup></span>{' '}
        <span>Benjamin Vella<sup>4</sup></span>{' '}
        <span>Armando Hoch<sup>3</sup></span>{' '}
        <span>Siyu Tang<sup>2</sup></span>{' '}
        <span>Philipp Fürnstahl<sup>3</sup></span>{' '}
        <span>Helmut Grabner<sup>1</sup></span>
      </section>
      <section className="authors" style={{ marginTop: 20, fontSize: '1rem', lineHeight: 1.6, textAlign: 'center' }}>
        <div><strong><sup>1</sup></strong> Zurich University of Applied Sciences</div>
        <div><strong><sup>2</sup></strong> ETH Zurich</div>
        <div><strong><sup>3</sup></strong> Balgrist University Hospital</div>
        <div><strong><sup>4</sup></strong> University of Zurich</div>
      </section>
      <div className="responsive-badges" style={{ display: 'flex', justifyContent: 'center', gap: 20, margin: '30px 0', flexWrap: 'wrap' }}>
        <a href="https://boneandjoint.org.uk/journal/bjj" target="_blank" rel="noopener noreferrer" className="button badge-btn" style={{ display: 'flex', alignItems: 'center', background: '#e6f7e6', border: '2px solid #4caf50', borderRadius: 12, padding: '12px 24px', fontSize: '1.1rem', fontWeight: 'bold', color: '#256029', boxShadow: '0 2px 8px rgba(76,175,80,0.08)', textDecoration: 'none', margin: 0 }}>
          <span style={{ marginLeft: 6, fontStyle: 'italic' }}>The Bone & Joint Journal</span>
        </a>
        <a href="https://www.caos-international.org/" target="_blank" rel="noopener noreferrer" className="button badge-btn" style={{ display: 'flex', alignItems: 'center', background: '#e3f2fd', border: '2px solid #1976d2', borderRadius: 12, padding: '12px 24px', fontSize: '1.1rem', fontWeight: 'bold', color: '#0d305a', boxShadow: '0 2px 8px rgba(25,118,210,0.08)', textDecoration: 'none', margin: 0 }}>
          <span style={{ marginLeft: 6, fontStyle: 'italic' }}>CAOS 2025</span>, Podium Award
        </a>
      </div>
      <section style={{ textAlign: 'center' }}>
        <a className="button" href="https://github.com/panteroni/3dsurgerytraining/blob/c6e5c703fd913be216032b9ba9e65e549c926a52/Enhancing_Orthopedic_Surgical_Training_With_Interactive_Photorealistic_3D_Visualization.pdf" download target="_blank" rel="noopener noreferrer" style={{ margin: '10px 10px', display: 'inline-block' }}>
          Download Paper
        </a>
        <a href="http://arxiv.org/abs/2506.13389" download target="_blank" rel="noopener noreferrer" className="button" style={{ margin: '10px 10px', display: 'inline-block' }}>
          arXiv Paper
        </a>
      </section>
      <section>
        <h2>Abstract</h2>
        <p>Surgical training integrates several years of didactic learning, simulation, mentorship, and hands-on experience. Challenges include stress, technical demands, and new technologies. Orthopedic education often uses static materials like books, images, and videos, lacking interactivity. This study compares a new interactive photorealistic 3D visualization to 2D videos for learning total hip arthroplasty. In a randomized controlled trial, participants (students and residents) were evaluated on spatial awareness, tool placement, and task times in a simulation. Results show that interactive photorealistic 3D visualization significantly improved scores, with residents and those with prior 3D experience performing better. These results emphasize the potential of the interactive photorealistic 3D visualization to enhance orthopedic training.</p>
      </section>
      <section>
        <h2>The Paper</h2>
        <p>This study shows that an interactive 3D tool outperforms standard 2D videos in teaching total hip arthroplasty, especially for residents and users with prior 3D experience.</p>

      </section>
      <section>
        <h2>BibTeX</h2>
        <div className="bibtex-container" style={{ position: 'relative', background: '#2d2d2d', color: '#f8f8f2', paddingTop: '3rem', borderRadius: 8, fontFamily: 'Courier New, Courier, monospace', fontSize: '0.9rem', lineHeight: 1.5, overflowX: 'auto' }}>
          <pre style={{ margin: '1rem', paddingRight: '2rem' }}>{`
@inproceedings{lekarOrthopedicVisualization,
  title     = {Enhancing Orthopedic Surgical Training With Interactive Photorealistic 3D Visualization},
  author    = {Roni Lekar and Tatiana Gerth and Sergey Prokudin and Matthias Seibold and Reto Bürgin and Benjamin Vella and Armando Hoch and Siyu Tang and Philipp Fürnstahl and Helmut Grabner},
  booktitle = {Proceedings of The 25th Annual Meeting of the International Society for Computer Assisted Orthopaedic Surgery},
  year      = {2025},
  publisher = {EasyChair},
  bibsource = {EasyChair, https://easychair.org},
  institution = {Zurich University of Applied Sciences, ETH Zurich, Balgrist University Hospital, University of Zurich},
}`}</pre>
        </div>
      </section>
      <section style={{ border: '2px dashed #ccc', borderRadius: 8, background: 'repeating-linear-gradient(45deg, #f6f9ff, #f6f9ff 10px, #ffffff 10px, #ffffff 20px)' }}>
        <h2>Title</h2>
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum..</p>
        <div style={{ textAlign: 'right' }}>
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <a href="/" className="button" style={{ textAlign: 'center' }}>
              Try now
            </a>
          </div>
        </div>
      </section>
      <hr style={{ border: 'none', borderTop: '1px solid #ccc' }} />
      <Footer />

    </div>
  );
};

export default Paper;
